<template>
  <div id="main_footer_v2_container">
    <div id="main_footer_v2">
      <div class="column">
        <img src="@/assets/imgs/new_logo_abbreviated.svg" id="logo" />
        <p>Dev Null Productions</p>
        <p>48 Wall Street, #1100</p>
        <p>NYC, New York 10005</p>

        <div id="copyright">
          <p>© Copyright 2018-2025</p>
          <p>Dev Null Productions</p>
          <p>All Rights Reserved</p>
        </div>
      </div>

      <div class="column">
        <p><b>Navigation</b></p>

        <p>
          <router-link to="/v2">
            Home
          </router-link>
        </p>

        <p>
          <a href="https://jointhetale.com">
            The Longest Tale
          </a>
        </p>

        <p>
          <a href="https://blocktr.ac">
            Block Trac
          </a>
        </p>

        <p>
          <router-link to="/v2/team">
            Our Team
          </router-link>
        </p>

        <p>
          <router-link to="/v2/mission">
            Our Mission
          </router-link>
        </p>

        <p>
          <router-link to="/v2/news">
            News &amp; Announcements
          </router-link>
        </p>

        <p>
          <router-link to="/v2/terms">
            Terms &amp; Conditions
          </router-link>
        </p>

        <p>
          <router-link to="/v2/privacy">
            Privacy Policy
          </router-link>
        </p>
      </div>

      <div class="column">
        <p><b>Useful links</b></p>

        <p>
          <a href="https://store.steampowered.com/search/?developer=Dev%20Null%20Productions">
            Dev Null Productions at Steam
          </a>
        </p>

        <p>
          <a href="https://store.steampowered.com/app/3507360/The_Longest_Tale/">
            The Longest Tale at Steam
          </a>
        </p>
      </div>

      <div class="column" id="main_footer_v2_subcontainer">
        <div id="newsletter_container">
          <p><b>
            <router-link to="/v2#newsletter">Sign up for our NEWSLETTER</router-link>
          </b></p>
        </div>

        <div id="channels_container">
          <p><b>Our channels</b></p>
          <div id="channels">
            <a href="https://instagram.com/devnullprod">
              <img src="@/assets/imgs/IG.svg" />
            </a>

            <a href="https://x.com/devnullprod">
              <img src="@/assets/imgs/X.svg" />
            </a>

            <a href="https://www.youtube.com/@devnullprod">
              <img src="@/assets/imgs/YT.svg" />
            </a>

            <a href="https://twitch.com/devnullprod">
              <img src="@/assets/imgs/Twitch.svg" />
            </a>

            <a href="https://store.steampowered.com/search/?developer=Dev%20Null%20Productions">
              <img src="@/assets/imgs/Steam.svg" />
            </a>

            <a href="https://www.linkedin.com/company/devnullprod">
              <img src="@/assets/imgs/linkedin.svg" />
            </a>

            <a href="https://www.facebook.com/people/Dev-Null-Prod/100063785149118/">
              <img src="@/assets/imgs/FB.svg" />
            </a>

            <a href="https://www.tiktok.com/@devnullprod">
              <img src="@/assets/imgs/TikTok.svg" />
            </a>

            <a href="https://bsky.app/profile/devnullprod.bsky.social">
              <img src="@/assets/imgs/BlueSky.svg" />
            </a>

            <a href="https://www.threads.net/@devnullprod">
              <img src="@/assets/imgs/Threads.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFooterV2'
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';
#main_footer_v2_container{
  border: 1px solid $white-alpha3;
  border-bottom: none;
  border-radius: 15px;
  color: $white;
  background-image: linear-gradient($grey-7-alpha75, $black-alpha62);
}

#main_footer_v2{
  padding: 35px 150px 25px 150px;
  display: flex;
  justify-content: space-between;
  font-family: Alliance No2;
  font-size: 14px;
}

#main_layout_v2.lg #main_footer_v2{
  padding: 35px 15px 25px 15px;
}

#main_layout_v2.md #main_footer_v2{
  font-size: 12px;
}

#main_layout_v2.md #main_footer_v2{
  padding: 25px 15px 25px 15px;
}

#main_layout_v2.sm #main_footer_v2,
#main_layout_v2.xs #main_footer_v2{
  padding: 25px;
  flex-direction: column;
}

#main_footer_v2 b{
  font-family: Alliance No2 Bold;
}

#main_footer_v2 .column{
  display: flex;
  flex-direction: column;
}

#main_layout_v2.sm #main_footer_v2 .column,
#main_layout_v2.xs #main_footer_v2 .column{
  margin-bottom: 25px;
}

#main_footer_v2_subcontainer{
  border: 1px solid $eerie-black;
  border-radius: 15px;
  padding: 15px;
  background-image: linear-gradient($grey-7-alpha75, $black-alpha62);
}

#main_layout_v2.md #main_footer_v2_subcontainer{
  padding: 10px;
}

#main_footer_v2 #main_footer_v2_subcontainer p{
  margin-bottom: 15px;
}

#main_footer_v2 p{
  margin-bottom: 0;
}

#main_footer_v2 a{
  color: $white;
}

#logo{
  width: 88px;
  height: 42px;
}

#copyright{
  margin-top: auto;
}

#main_layout_v2.md #copyright{
  margin-top: 15px;
}

#newsletter_container{
  border: 1px solid $eerie-black;
  border-radius: 15px;
  padding: 10px;
  background-image: linear-gradient($grey-7-alpha75, $black-alpha62);
}


#main_layout_v2.sm #newsletter_container,
#main_layout_v2.xs #newsletter_container{
  text-align: center;
}

#newsletter_container a:hover{
  text-decoration: none;
}

#main_footer_v2 #main_footer_v2_subcontainer #newsletter_container p{
  margin-bottom: 0;
  cursor: pointer;
}

#channels_container{
  margin-top: 15px;
  border: 1px solid $eerie-black;
  border-radius: 15px;
  padding: 25px;
  background-image: linear-gradient($grey-7-alpha75, $black-alpha62);
}

#main_layout_v2.md #channels_container{
  padding: 15px;
}

#main_layout_v2.sm #channels_container,
#main_layout_v2.xs #channels_container{
  text-align: center;
}

#channels{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 175px;
  gap: 15px;
}

#main_layout_v2.sm #channels,
#main_layout_v2.xs #channels{
  margin: auto;
}

#channels img{
  width: 20px;
}
</style>
